import { useQuery } from '@tanstack/react-query';
import { useAuth, WorkspaceSubscriptionWithApp, appService } from '@aaas/shared';

interface UseWorkspaceSubscriptionsOptions {
  all?: boolean; // If true, fetch all subscriptions (admin view)
}

export function useWorkspaceSubscriptions(
  workspaceId: string | undefined,
  options?: UseWorkspaceSubscriptionsOptions
) {
  const { user } = useAuth();
  const all = options?.all ?? false;

  return useQuery({
    queryKey: ['workspace-subscriptions', workspaceId, all],
    queryFn: async (): Promise<WorkspaceSubscriptionWithApp[]> => {
      if (!workspaceId || !user) {
        throw new Error('Workspace ID and user required');
      }
      const idToken = await user.getIdToken();
      return appService.getWorkspaceSubscriptions(workspaceId, idToken, all);
    },
    enabled: !!workspaceId && !!user,
  });
}
